export default {"src":"/_next/static/media/WhoWeAre_027A.6959e481.JPG","height":724,"width":1920};